export const INTEREST_LIST_ID = null;
export const AVAILABLE_ID = 0;
export const PROVISIONAL_ID = 1;
export const FINAL_ID = 2;

export const TOURNAMENT_STATUS_BY_ID = {
  AVAILABLE: AVAILABLE_ID,
  PROVISIONAL: PROVISIONAL_ID,
  FINAL: FINAL_ID
};
